import { Link } from "@inertiajs/react";
import App from "../layouts/app";
import { Pen } from 'lucide-react';
import { BalanceCard } from "../components/BalanceCard";
import { PriceBlock } from "../components/PriceBlock";
import { useBinanceTrade } from "../hooks/useBinanceTrade";
import { Grid, useBinanceState } from "../contexts/BinanceContext";
import { useEffect } from "react";
import { OpenTradesBlock } from "../components/OpenTradesBlock";
import { useSpotPositions } from "../hooks/useSpotPositions";
import { SpotPositionsBlock } from "../components/SpotPositionsBlock";
import "../../css/app.css"
import { BinanceStable, useBinanceTicker } from "../hooks/useBinanceTicker";
import { PriceBlockWithChart } from "../components/PriceBlockWithChart";
import Requester from "../helpers/Requester";
import { GridProfitCalculator } from "../components/GridProfitCalculator";
import { GridCard } from "../components/GridCard";
import { GridsTable } from "../components/GridTable";
import { GridLevelsBar } from "../components/GridLevelsBar";


export default function Dashboard({ balances: initialBalances, prices: initialPrices, orders, openOrders: initialOpenOrders, trades, grids: initialGrids }: { balances: Record<string, any>, prices: Record<string, any>, orders: any[], openOrders: any[], trades: any[], grids: Grid[] }) {

    const { balances, prices, openTrades, setBalances, setPrices, setOpenTrades, priceDirections, grids, setGrids } = useBinanceState();

    useEffect(() => {
        setBalances(initialBalances);
        setPrices(initialPrices);
        setOpenTrades(initialOpenOrders);
        setGrids(initialGrids);
    }, [initialBalances, initialPrices, orders, initialOpenOrders, initialGrids]);

    useBinanceTrade();
    const positions = useSpotPositions(trades, prices);

    const { connected, isStable } = useBinanceTicker('LINK', BinanceStable.FDUSD);

    // const startGrid = () => {
    //     const requester = new Requester();

    //     requester.post(requester.getUrl('api/grid')).then((response) => {
    //         console.log(response);
    //     });
    // }

    return (
        <App>
            <div className="w-full">
                <div className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-20 pt-0 flex flex-col space-y-7">
                    <div className="flex items-center justify-between">
                        <h1 className="text-3xl font-medium">Dashboard</h1>
                        {/* <button onClick={startGrid} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md">Start Grid</button> */}
                    </div>
                    <div className="bg-white shadow rounded-xl p-6 border border-gray-200">
                        <h2 className="text-xl font-semibold mb-4">Цены на ключевые пары</h2>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            <PriceBlockWithChart price={prices['SOLFDUSD']} pair="SOL/FDUSD" isUp={priceDirections['SOLFDUSD'] ?? null} />
                            <PriceBlockWithChart price={prices['LINKFDUSD']} pair="LINK/FDUSD" isUp={priceDirections['LINKFDUSD'] ?? null} />
                        </div>
                    </div>

                    <GridProfitCalculator symbol='SOLFDUSD' />

                    <GridLevelsBar orders={grids.filter(grid => grid.status === "running").map(grid => grid.orders.filter(order => order.status === "open")).flat().map((order) => {
                        return { id: order.id, price: order.price, type: order.type, filled: order.status === "filled" }
                    })} currentPrice={parseFloat(prices['SOLFDUSD'] ?? '0')} />

                    <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4">
                        {grids.filter(grid => grid.status === "running").map((grid: any) => (
                            <GridCard key={grid.id} grid={grid} />
                        ))}
                    </div>

                    {/* <GridsTable grids={grids} onSelect={() => { }} /> */}

                    <SpotPositionsBlock positions={positions} />

                    <OpenTradesBlock trades={openTrades.map((order: any) => {
                        return {
                            symbol: order.symbol,
                            entryPrice: parseFloat(order.price),
                            amount: parseFloat(order.origQty),
                            currentPrice: parseFloat(prices[order.symbol] ?? '0'),
                            isBuy: order.side === 'BUY',
                        }
                    })} />
                    <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4">
                        {Object.keys(balances).map((symbol) => {
                            if (balances[symbol].available > 0 || balances[symbol].onOrder > 0) {
                                return <BalanceCard key={symbol} symbol={balances[symbol]} price={prices[symbol + 'FDUSD'] ?? prices['FDUSD' + symbol]} />
                            }
                        })}
                    </div>
                </div>
            </div>
        </App>
    )
}